<a class="skip-link" href="#main-content">Saltar al contenido principal</a>

<div class="app-shell" [class.app-shell--sidebar]="sidebarMode()">
  <app-nav [sidebarMode]="sidebarMode()"></app-nav>

  <main
    id="main-content"
    class="app-main"
    [class.app-main--sidebar]="sidebarMode()"
    [class.app-main--public]="!sidebarMode()"
  >
    <router-outlet></router-outlet>
  </main>
</div>
